<template>
  <div>
    <div v-if="loading" class="mt-2">
      <center>
        <a-spin/>
      </center>
    </div>
    <div v-else>
      <a-col :span="24">
        <router-link :to="{name: 'permissions-edit'}">
          <button class="btn btn-large" style="float:right">
            <a-icon type="form" style="padding-right:7px"/>Edit Permission
          </button>
        </router-link>
      </a-col>
      <a-col :span="24" class="pr-2">
        <h5 class="text-opacity">Permission Name</h5>
        <h4>{{permission.name.split("-").join(" ")}}</h4>
      </a-col>
      <a-col :span="24" class="pt-2 pr-2">
        <h5 class="text-opacity">Permission description</h5>
        <h4>{{permission.description}}</h4>
      </a-col>
      <a-col :span="24" class="pt-2 pr-2">
        <h5 class="text-opacity">Created At</h5>
        <h4>{{permission.created | mnt}}</h4>
      </a-col>
      <a-col :span="24" class="pt-2 pr-2">
        <h5 class="text-opacity">Roles</h5>
        <div v-if="permission && permission.roles && permission.roles.length >= 1">
          <a-tag :key="index" v-for="(role,index) in permission.roles">{{role.name}}</a-tag>
        </div>
        <div v-else>
          <h4>No assigned Role(s) yet.</h4>
        </div>
      </a-col>
      <a-col :span="24" class="pt-2 pr-2 pb-2">
        <h5 class="text-opacity">Status</h5>
        <h4 v-if="permission.active">
          <a-badge status="success"/>Active
        </h4>
        <h4 v-else>
          <a-badge status="error"/>Deactivated
        </h4>
      </a-col>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      loading: true,
      permission: {
        id: "",
        name: "",
        description: "",
        active: "",
        created_at: ""
      }
    };
  },
  methods: {
    fetchPermission() {
      this.$store
        .dispatch("getPermission", this.$route.params.id)
        .then(s => {
          this.loading = false;
          this.permission = s.data;
        })
        .catch(() => {
          this.$message.error("Record for your request was not found!");
        });
    }
  },
  mounted() {
    this.fetchPermission();
  },
  filters: {
    mnt(t) {
      return moment(t).format("Do MMMM, YYYY");
    }
  }
};
</script>